import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { parametersQueries } from '../../queryClient/parameters/parameters.queries';
import { SmOktaAuth } from '../../utils/oktaInstance';

const InitializeOkta = ({ children }: { children: ReactNode }) => {
  const history = useHistory();
  const { systemParams } = parametersQueries.useSystemParameters();

  const oktaAuth = SmOktaAuth.getInstance({
    clientId: systemParams?.okta_client_id,
    issuer: systemParams?.okta_token_issuer,
    redirectUri: systemParams?.okta_redirect_uri
  });

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default InitializeOkta;
